import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from '../pages/HomePage';
import FormPage from '../pages/FormPage/FormPage';
import MapPage from '../pages/MapPage/MapPage';
import Whodunit2026Page from '../pages/Whodunit2026Page/Whodunit2026Page';
import Navigation from '../components/Navigation/Navigation';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/events/be-our-witness/form" element={
          <>
            <Navigation />
            <div className="main-content">
              <FormPage />
            </div>
          </>
        } />
        <Route path="/map" element={
          <>
            <Navigation />
            <div className="main-content">
              <MapPage />
            </div>
          </>
        } />
        <Route path="/whodunit2026" element={<Whodunit2026Page />} />
        <Route path="/whodunit2026/reset" element={<Whodunit2026Page action="reset" />} />
        <Route path="/whodunit2026/exit" element={<Whodunit2026Page action="exit" />} />
      </Routes>
    </div>
  );
}

export default App;
